<h1 matDialogTitle>Search Stock Code</h1>

<mat-dialog-content style="overflow: hidden;">
  <optsol-ngx-data-table-with-search-criteria [tableConfigRequest]="stockCodesTableConfigRequest"
    [tableDataRequest]="stockCodesTableDataRequest" [searchCriteriaConfigRequest]="stockCodesSearchCriteriaRequest"
    [(selectedKeys)]="selectedKeys" (actionButtonClicked)="actionButtonClicked($event)">
  </optsol-ngx-data-table-with-search-criteria>
</mat-dialog-content>

<mat-dialog-actions>
    <button mat-button matDialogClose>Close</button>
</mat-dialog-actions>